import { Select, SelectProps } from '@mui/material';
import { ReactNode } from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

interface SelectComponentProps extends Omit<SelectProps, 'children'> {
  children: ReactNode;
  inputLabel?: string;
  id?: string;
}

export function BaseSelect({ children, inputLabel, id = '', ...otherProps }: SelectComponentProps) {
  return (
    <FormControl fullWidth className="select-dropdown">
      {inputLabel && <InputLabel id={id}>{inputLabel}</InputLabel>}
      <Select labelId="demo-simple-select-label" id={id} {...otherProps}>
        {children}
      </Select>
    </FormControl>
  );
}
